import { Dispatch } from "redux";
import { connect } from "react-redux";

import UploadDocument from "./uploadDocument";
import { AppState } from "../../core/reducers/rootReducer";
import { UploadDocumentActions } from "../../core/actionTypes/uploadDocumentActionTypes";
import { getInstitutionList, initiateUploadDoc, uploadDocuments, uploadDetails, uploadDocumentReset } from "../../core/actionCreators/uploadDocumentActionCreators";
import * as uploadDocumentActions from "../../core/actionTypes/uploadDocumentActionTypes";
import { getTransactionIdFromURL, isUserLoggedIn } from "../../constants/utils";
import { getTransactionSummaryConsentReset } from "../../core/actionCreators/paymentSummaryActionCreators";
import { PaymentAction } from "../../core/actionTypes/paymentSummaryActionTypes";

const mapDispatchToProps = (dispatch: Dispatch<UploadDocumentActions | PaymentAction>) => ({
  fetchInstitutionList: (query: string) => {
    dispatch(getInstitutionList(query));
  },
  initiateUploadDocuments: (request: object) => {
    dispatch(initiateUploadDoc(request))
  },
  uploadDocuments: (perfTxnId: string, documents: FormData) => {
    dispatch(uploadDocuments(perfTxnId, documents))
  },
  uploadDetails: (request: object) => {
    dispatch(uploadDetails(request))
  },
  resetTransactionSummary: () => {
    dispatch(getTransactionSummaryConsentReset())
  },
  uploadDocumentReset: () => {
    dispatch(uploadDocumentReset())
  }
});

const mapStateToProps = (state: AppState) => {
  let txnId = getTransactionIdFromURL();
  return {
    transactionDetails: state.transactionDetails,
    institutionList: state.upload.institutionList,
    perfiosTxnId: state.upload.initiateResponse,
    inAppBackPressed: state.config.inAppBackPressed,
    uploadDocumentResponse: state.upload.uploadDocumentResponse,
    uploadDocumentCompleted: state.upload.uploadDocumentCompleted,
    isLoading: state.isLoading[uploadDocumentActions.INITIATE_UPLOAD_DOC] || state.isLoading[uploadDocumentActions.UPLOAD_DOCUMENTS],
    error: state.error[uploadDocumentActions.GET_INSTITUTION_LIST] || state.error[uploadDocumentActions.INITIATE_UPLOAD_DOC] || state.error[uploadDocumentActions.UPLOAD_DOCUMENTS],
    isAuthenticated: isUserLoggedIn(txnId),
    resumeJourneyEligibility: state.auth.resumeJourneyEligibility,
    uploadDetailsResponse: state.upload.uploadDetailsResponse,
    partnerData: state.auth,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UploadDocument);
